import { render, staticRenderFns } from "./FilterByCategory.vue?vue&type=template&id=177d4c4c&scoped=true&"
import script from "./FilterByCategory.vue?vue&type=script&lang=js&"
export * from "./FilterByCategory.vue?vue&type=script&lang=js&"
import style0 from "./FilterByCategory.vue?vue&type=style&index=0&id=177d4c4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "177d4c4c",
  null
  
)

export default component.exports